import { useEffect } from 'react';
import { useUIStore } from '@/stores/uiStore';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useAssistantSideBySide } from '@/components/assistant/assistantLayout';
import { SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_WIDTH } from '@/components/layout/Sidebar';
import { setGuideSideBySideAvailable } from '@/lib/guides/engine';

/**
 * Publishes the same side-by-side answer the Buddy panel uses, so `start()`
 * can refuse a guide when the panel would cover the page.
 */
export function GuideLayoutBridge(): null {
  const isMobile = useIsMobile();
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed);
  const sidebarWidth = isMobile ? 0 : sidebarCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;
  const sideBySide = useAssistantSideBySide(sidebarWidth);

  setGuideSideBySideAvailable(sideBySide);

  useEffect(() => {
    return () => {
      setGuideSideBySideAvailable(null);
    };
  }, []);

  return null;
}
